import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "splide__slide" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "inner" }
const _hoisted_4 = {
  key: 0,
  class: "logo"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 1,
  class: "tag"
}
const _hoisted_7 = {
  key: 2,
  class: "heading"
}
const _hoisted_8 = { class: "preview" }
const _hoisted_9 = ["srcset"]
const _hoisted_10 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("a", {
      href: _ctx.result.url,
      class: "card"
    }, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.result?.images?.clientLogo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.result?.images?.clientLogo?.url.toCropUrl(190, 90),
                alt: _ctx.result?.images?.clientLogo?.altText
              }, null, 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
        (_ctx.result?.additionalFields.previewTag)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "color" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.result?.additionalFields.previewTag), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.result?.pageTitle)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_7, _toDisplayString(_ctx.result?.pageTitle), 1))
          : _createCommentVNode("", true),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "arrow" }, [
          _createElementVNode("svg", {
            role: "img",
            "aria-hidden": "true",
            xmlns: "http://www.w3.org/2000/svg",
            width: "22",
            height: "12",
            fill: "#fff"
          }, [
            _createElementVNode("path", { d: "M10 5h2v2h-2zM5 5h2v2H5zM0 5h2v2H0z" }),
            _createElementVNode("path", { d: "M14.795 10.123l1.522 1.522 3.804-3.804 1.522-1.522h0l-1.522-1.522h-.001L16.316.992l-1.522 1.522 3.805 3.805-3.804 3.804z" })
          ])
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("picture", null, [
          _createElementVNode("source", {
            srcset: 
              _ctx.result?.images?.previewImage?.url.toCropUrl(400, 464) ||
                _ctx.defaultSiteImageUrl.toCropUrl(400, 464)
            ,
            media: "(min-width: 0px)"
          }, null, 8, _hoisted_9),
          _createElementVNode("img", {
            src: 
              _ctx.result?.images?.previewImage?.url.toCropUrl(400, 464) ||
                _ctx.defaultSiteImageUrl.toCropUrl(400, 464)
            ,
            alt: _ctx.result?.images?.previewImage?.altText
          }, null, 8, _hoisted_10)
        ])
      ])
    ], 8, _hoisted_2)
  ]))
}